import { defineStore } from "pinia";

export const useMasterCreateStore = defineStore("masterCreateStore", {
  state: () => ({
    step: null,
    mode: null,
  }),
  actions: {
    setValue(keyValue) {
      if (keyValue?.key in this) {
        this[keyValue.key] = keyValue.value;
      }
    },
    SET_VALUE(keyValue) {
      this.setValue(keyValue);
    },
  },
});

export default useMasterCreateStore;
